import React, {Component} from 'react';
import {Spin} from 'antd';

export default class GoogleMapsLoadingContainer extends Component {
    render() {
        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999
            }}>
                <Spin size="large" />
            </div>
        );
    }
}
